var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-fixed tw-w-full tw-bottom-8 tw-justify-center tw-text-center"},[_c('button',{staticClass:"tw-p-12 tw-bg-white tw-rounded-full tw-font-bold tw-shadow-xl",on:{"click":function($event){return _vm.actionBtn()}}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("mdi-arrow-left")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }